// Auto-generated normalizer for table: CAR_BOOKING.CatTipoVehiculo
export function catTipoVehiculoNormalize(row) {
  return {
    idTipoVehiculo: row.idTipoVehiculo ?? row.IdTipoVehiculo ?? row['idTipoVehiculo'] ?? 0,
    clave: row.clave ?? row.Clave ?? row['clave'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['descripcion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['fechaCreacion'] ?? null,
  };
}